var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-chart"},[(Object.keys(_vm.chart).length === 0 || _vm.chart.reporting_data.length === 0)?_c('h2',[_vm._v(" No data generated for this interval. ")]):_c('SummaryComponent',{attrs:{"chart":_vm.chart}}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }